import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { CapabilityEngineService } from '../capabilityEngine.service';

@Injectable()
export class SubmittedFormListService {

    constructor(
        private _http: HttpClient,
        private _capEngineService: CapabilityEngineService
    ) { }


    getTasksByTemplateId(templateId) {
        return this._http.get(environment.serverUrl + '/taskTemplate/tasks/' + templateId);
    }

    performPagination(templateId, pageNumber, formType, displayFieldKey) {
        let header: any = this._capEngineService.getHeaders('viewTaskList');
        header.params = { formType: formType, displayFieldKey: displayFieldKey };
        // tslint:disable-next-line:max-line-length
        return this._http.get(environment.serverUrl + '/task/' + templateId + '/tasks/pagination/' + pageNumber, header);
    }

    getFilteredTasks(dataObj, pageNumber) {
        let header: any = this._capEngineService.getHeaders('viewTaskList');
        header.params = dataObj;
        return this._http.get(environment.serverUrl + '/tasks/getFilteredTasks/' + pageNumber, header);
    }

    getTasksOnSearch(searchString, templateId, pageNumber, isHazardForm) {

        let header: any = this._capEngineService.getHeaders('viewTaskList');
        header.params = { isHazardForm: isHazardForm };

        // tslint:disable-next-line:max-line-length
        return this._http.get(environment.serverUrl + '/task/search/' + searchString + '/template/' + templateId + '/pagination/' + pageNumber, header);
    }

    downloadMultipleCSV(Obj) {
        return this._http.post(environment.serverUrl + '/task/downloadMultiplePdf', Obj, { responseType: 'blob' });
    }

    downloadLHoistCSV(Obj) {
        return this._http.post(environment.serverUrl + '/lhoist/excel', Obj, { responseType: 'blob' });
    }

    downloadMultiplePdf(Obj) {
        return this._http.post(environment.serverUrl + '/task/downloadtaskpdfs', Obj, { responseType: 'blob' });
    }

    downloadAuthentication(password) {
        return this._http.post(environment.serverUrl + '/user/verifyPassword', password);
    }

    downloadvoltasAvailabilityExcel(Obj) {
        return this._http.post(environment.serverUrl + '/voltas/excel/availability', Obj, { responseType: 'blob' });
    }

    downloadVoltasActionReportExcel(Obj) {
        return this._http.post(environment.serverUrl + '/voltas/excel/actionReport', Obj, { responseType: 'blob' });
    }

    downloadVoltasFioreShiftReport(Obj) {
        return this._http.post(environment.serverUrl + '/voltas/excel/fioreShiftReport', Obj, { responseType: 'blob' });
    }

    uploadExcel(file, tempateId) {
        var fileFormData = new FormData();
        fileFormData.append('file', file);
        fileFormData.append('templateId', tempateId);

        return this._http.post(environment.serverUrl + '/tasks/excelupload', fileFormData)
    }

    downloadDynoDailyActityReport(requestData) {
        return this._http.post(environment.serverUrl + '/dyno/pdf/dailyActivityReport', requestData, { responseType: 'blob' });
    }

    assignHazardToUser(formId, payload) {
        return this._http.put(environment.serverUrl + `/task/hazard/${formId}/assign`, payload);
    }
}



// WEBPACK FOOTER //
// ./src/app/submitted-form-list/submitted-forms-list.service.ts